import { useNavigate } from 'react-router-dom'
import React, { useState } from 'react'
import { type ShortOAuth2App } from '../../../store/auth/auth'
import { OAuth2AppsButtonManager } from '../../../views/OAuth2App/OAuth2AppManagement/Components/OAuth2AppsButtonManager'
import { CommonCard } from '../../Card/CommonCard'
import '../../AppCard/AppCard.scss'
import { OAuth2AppsModalManager, OAuth2AppsModalType } from '../../../views/OAuth2App/OAuth2AppManagement/Modals/OAuth2AppsModalManager'
import { AppCardHeader } from '../../AppCard/AppCardHeader'

export interface OAuth2AppCardProps {
  oAuth2App: ShortOAuth2App
}

export const OAuth2AppCard: React.FC<OAuth2AppCardProps> = ({ oAuth2App }) => {
  const { name, clientId, imageUrl, shortDescription, type } = oAuth2App
  const navigate = useNavigate()

  const showPrivateBadge = type === 'dev' || type === 'internal'

  const [activeModal, setActiveModal] = useState<OAuth2AppsModalType>(null)

  const handleCardClick = () => {
    navigate(`/account/integration-settings/oauth2apps/${clientId}/about`)
  }

  const descriptionView = (
    <div className='h-auto'>
      <span className='heading-small zocks-text-gray-900'>{name}</span>
      <div className='zocks-text-gray-600'>{shortDescription}</div>
    </div>
  )

  return (
    <>
      <OAuth2AppsModalManager oAuth2App={oAuth2App} activeModal={activeModal} onClose={() => setActiveModal(null)} />
      <CommonCard
        onCardClick={handleCardClick}
        header={<AppCardHeader name={name} imageUrl={imageUrl} showPrivateBadge={showPrivateBadge} />}
        description={<div>{descriptionView}</div>}
        state={<></>}
        footer={
          <OAuth2AppsButtonManager
            oAuth2App={oAuth2App}
            hideDisableButton={true}
            hideRevokeAccessButton={true}
            onRequestModal={(modal) => setActiveModal(modal)}
          />
        }
      />
    </>
  )
}
